import { Box, Grid, GridItem, Text, Stat, StatLabel, StatNumber, StatHelpText, StatArrow, Heading, Skeleton, Flex, Divider } from '@chakra-ui/react';
import React, { useState, useRef, useEffect } from 'react';
import Sidebar from '../components/Sidebar';


const Teste = () => {

    return <>
        <Sidebar />
        <Text>Testando</Text>
    </>;
};


export default Teste;
